import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuth: '',
  username: ''
};

export const isAuthSlice = createSlice({
  name: 'isAuth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuth = action.payload.isAuth;
      state.username = action.payload.username;
    },
    logout: (state) => {
      return initialState;
    }
  }
});

export const { login, logout } = isAuthSlice.actions;
export default isAuthSlice.reducer;
